import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdministrationComponent } from './administration.component';
import { UserComponent } from './users/user/user.component';
import { UsersComponent } from './users/users.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { FilterAutocompleteComponent } from "@nucleus/ui-base";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { AdministrationRoutingModule } from './administration-routing.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { AccessRequestManagementComponent } from './access-request-management/access-request-management.component';
import { RunnersAdminComponent } from './runners/runners.component';
import { RunnerAdminComponent } from './runners/runner/runner.component';
import { OrgUnitsComponent } from './org-units/org-units.component';
import { UserDataTypesComponent } from './userdata-types/userdata-types.component';
import { UserDataTypeDetailComponent } from './userdata-types/userdata-type-detail.component';
import { CapabilitiesComponent } from './capabilities/capabilities.component';
import { CapabilityDetailComponent } from './capabilities/capability-detail.component';
import { CapabilityCreateDialogComponent } from './capabilities/capability-create-dialog.component';
import { CapabilityFieldDialogComponent } from './capabilities/capability-field-dialog.component';
import { CapabilityDecommissionDialogComponent } from './capabilities/capability-decommission-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TableSkeletonComponent } from '@nucleus/ui-common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTreeModule } from '@angular/material/tree';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { JsonPathViewerComponent } from '../common/json-path-viewer/json-path-viewer.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { PageHeaderComponent } from "@nucleus/ui-base";
import { ListPageComponent } from "@nucleus/ui-base";
import { FormErrorSummaryComponent } from "@nucleus/form-error-summary-ui";
import { UsersListComponent, UserEditComponent, UserEditTabDirective } from '@nucleus/user-ui';
import { OrgUnitsListComponent } from '@nucleus/org-unit-ui';
import { IpBlacklistComponent } from './ip-blacklist/ip-blacklist.component';
import { ReferenceDataComponent } from './reference-data/reference-data.component';
import { ReferenceDataBucketsComponent as ReferenceDataBucketsHostComponent } from './reference-data/reference-data-buckets.component';
import { ReferenceDataListComponent, ReferenceDataEditComponent, ReferenceDataBucketsComponent } from '@nucleus/reference-data-ui';
import { ConnectorsComponent } from './connectors/connectors.component';
import { ConnectorListComponent, ConnectorEditComponent } from '@nucleus/connector-admin-ui';
import { NUCLEUS_USER_UI_PROVIDERS } from '../services/user-ui-adapters';
import { AccessRequestManagementComponent as LibAccessRequestManagementComponent } from '@nucleus/access-request-ui';
import { NUCLEUS_ACCESS_REQUEST_UI_PROVIDERS } from '../services/access-request-ui-adapters';



@NgModule({
  providers: [...NUCLEUS_USER_UI_PROVIDERS, ...NUCLEUS_ACCESS_REQUEST_UI_PROVIDERS],
  declarations: [
    AdministrationComponent,
    UserComponent,
    UsersComponent,
    AccessRequestManagementComponent,
    RunnersAdminComponent,
    RunnerAdminComponent,
    OrgUnitsComponent,
    UserDataTypesComponent,
    UserDataTypeDetailComponent,
    CapabilitiesComponent,
    CapabilityDetailComponent,
    CapabilityCreateDialogComponent,
    CapabilityFieldDialogComponent,
    CapabilityDecommissionDialogComponent,
    ReferenceDataComponent,
    ReferenceDataBucketsHostComponent,
    ConnectorsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    MatExpansionModule,
    MatTabsModule,
    MatIconModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatCardModule,
    MatDividerModule,
    FilterAutocompleteComponent,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    MatSidenavModule,
    MatSortModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTreeModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonToggleModule,
    JsonPathViewerComponent,
    PageHeaderComponent,
    ListPageComponent,
    FormErrorSummaryComponent,
    TableSkeletonComponent,
    NgxJsonViewerModule,
    UsersListComponent,
    UserEditComponent,
    UserEditTabDirective,
    OrgUnitsListComponent,
    IpBlacklistComponent,
    LibAccessRequestManagementComponent,
    ReferenceDataListComponent,
    ReferenceDataEditComponent,
    ReferenceDataBucketsComponent,
    ConnectorListComponent,
    ConnectorEditComponent,
    AdministrationRoutingModule
  ]

})
export class AdministrationModule { 

}
